import { leadershipModals } from "../modules/leadership-modals";

const aboutPage = (gsap, DrawSVGPlugin, ScrollTrigger, smoother, Swiper, FreeMode, Parallax, data) => {
  
  var keys = {37: 1, 38: 1, 39: 1, 40: 1};

  function preventDefault(e) {
    e.preventDefault();
  }

  function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
      preventDefault(e);
      return false;
    }
  }

  // modern Chrome requires { passive: false } when adding event
  var supportsPassive = false;
  try {
    window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
      get: function () { supportsPassive = true; } 
    }));
  } catch(e) {}

  var wheelOpt = supportsPassive ? { passive: false } : false;
  var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

  // call this to Disable
  function disableScroll() {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
    window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
    window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
    window.addEventListener('keydown', preventDefaultForScrollKeys, false);
  }

  // call this to Enable
  function enableScroll() {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
    window.removeEventListener('touchmove', preventDefault, wheelOpt);
    window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
  }
  
  const $modalTransplant = $('.modal-transplant').detach();
  
  $('body').append($modalTransplant);
  
  if (data.next.url.hash) {
    let $scrollItem = '#'+data.next.url.hash;
    setTimeout(() => {
      gsap.to(smoother, {
        scrollTop: smoother.offset($scrollItem, "top -100px"),
        duration: 1
      });
    }, 800);
  }
  
  /***************************************************************
    TIMELINE CAROUSEL
  ***************************************************************/
   
  //const $aboutTimeline = new Swiper('.timeline-carousel', {
  //  modules: [FreeMode, Parallax],
  //  speed: 1000,
  //  slidesPerView: 1,
  //  spaceBetween: 80,
  //  parallax: true,
  //  freeMode: {
  //    enabled: true,
  //    sticky: true,
  //  },
  //});
  
  //gsap.set('.draggable-progress', {drawSVG: '0%'});
    
  //$aboutTimeline.on('transitionStart', function () {
    
  //  let $progress = $aboutTimeline.progress * 100;
    
  //  let progress = Math.round($progress);
        
  //  gsap.to('.draggable-progress', {duration: 0.8, ease: 'none', drawSVG: progress + '%'});
        
  //});
  
  //$aboutTimeline.on('reachBeginning', function() {
  //  setTimeout(() => {
  //    gsap.to('.draggable-progress', {duration: 0.8, ease: 'none', drawSVG: '0%'});
  //  }, 1000);
  //})
  
  /***************************************************************
    LEADERSHIP GRID
  ***************************************************************/
 
  const $leaders = $('.leader');
  
  $leaders.each(function() {
    
    const $this = $(this);
    const $imgs = $this.find('.collage > img');
    
    if ($imgs.length) {
      const tl = gsap.timeline({paused: true, repeat: -1});

      tl.fromTo($imgs, { visibility: 'hidden' }, { visibility: 'visible', duration: 0.35, stagger: 0.35});

      $this.on('mouseenter', function() {
        tl.play();
      }).on('mouseleave', function() {
        tl.progress(0).pause();
        tl.revert();
      });
    }
    
  });
    
  const $secondaryLeaders = $('.leadership-secondary');
  const $leadersMore = $('#leadersMore');
  const $btnText = $leadersMore.find('span');
  const $returnElem = $('.leadership-grid .row div:nth-child(6)');
  
  $leadersMore.on('click', function() {
    
    disableScroll();
    //smoother.paused(true);
        
    $(this).toggleClass('open');
    
    if ($btnText.text() == 'more') {
      
      $secondaryLeaders.slideToggle(600, function() {
        
        gsap.to(smoother, {
          scrollTop: smoother.offset($secondaryLeaders, "top 200px"),
          duration: 0.6,
          onComplete: function() {

            setTimeout(() => {
              ScrollTrigger.refresh();
              //smoother.paused(false);
              enableScroll();
            }, 10);
            
            $btnText.text('less');

          }
        });
        
      });
            
    } else {
      
      
      
        gsap.to(smoother, {
          scrollTop: smoother.offset($returnElem, "top -200px"),
          duration: 0.6,
          onComplete: function() {
            
            $secondaryLeaders.slideToggle(600, function() {

              setTimeout(() => {
                ScrollTrigger.refresh();
                //smoother.paused(false);
                enableScroll();
              }, 10);
              
              //ScrollTrigger.refresh(true);
            });
            
            $btnText.text('more');
            
          }
        });
        
    }
    
  });
  
  leadershipModals(gsap, smoother, ScrollTrigger);
       
}

export {
  aboutPage
};
